import { UITextField } from "../../_app/components";
import { createStylesheet } from "../../_app/utils/styles";

interface Props {
  value?: string;
  title?: string;
  hideLabel?: boolean;
  placeholder?: string;
  onChange?: any;
  [key: string]: any;
}

const UITextInput = ({ value, title, hideLabel = false, placeholder, onChange, ...props }: Props) => {
  const classes = useStyles();
  return (
    <UITextField
      variant="outlined"
      size="small"
      label={hideLabel ? null : title}
      name={title}
      value={value}
      onChange={(ev) => onChange(ev.target.value)}
      placeholder={placeholder}
      className={classes.ctr}
      fullWidth
      {...props}
    />
  );
};

const useStyles = createStylesheet(() => ({
  ctr: {},
}));

export default UITextInput;
